import { ActionIcon, Avatar, Box, Button, Group, Title } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { GET_COMPANY_INTEGRATION, SET_COMPANY_INTEGRATION } from "../../services/companies";
import InputField, { InputFieldTypes } from "../input_field";
import { FaCodeBranch, FaPlus, FaTrash } from "react-icons/fa";

export default function External(){
    const [data, setData] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);

    const clipboard = useClipboard();

    // const handleChange = dt => setData(u => ({ ...u, ...dt }))

    const loadData = () => {
        GET_COMPANY_INTEGRATION("app_data")
        .then((res) => {
            setData(res)
        })
        .catch(err => {
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }
    
    const handleSave = () => {
        setLoadingSave(true)
        
        SET_COMPANY_INTEGRATION("app_data", {...data}, [{key: "key"}])
        .then((res) => {
            setLoadingSave(false);
            loadData()
            showNotification({message: "Informações atualizadas", color: 'green'})
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    React.useEffect(() => { loadData() }, [])

    return <>
        <Group>
            <FaCodeBranch />
            <Title order={5}>Dados para o APP</Title>
        </Group>
        {
            (data?.infos ?? []).map((info, i) => (
                <Group mt="md">
                    <InputField
                        name="type"
                        style={{flex: 1}}
                        value={info.type}
                        onChange={({type}) => setData(d => ({...d, infos: d.infos.map((inf, j) => i === j ? {...inf, type} : inf)}))}
                        fieldType={InputFieldTypes.SELECT}
                        clearable={false}
                        searchable={false}
                        options={[
                            { label: 'E-mail', value: 'email' },
                            { label: 'Telefone', value: 'phone' },
                            { label: 'Website', value: 'website' },
                            { label: 'Imagem', value: 'image' },
                            { label: 'Whatsapp', value: 'whatsapp' },
                            { label: 'Texto', value: 'text' },
                            { label: 'Título', value: 'title' },
                        ]}
                        placeholder="Tipo"
                    />
                    <Box style={{flex: 1}}>
                        <InputField
                            name="value"
                            value={info.value}
                            onChange={({value}) => setData(d => ({...d, infos: d.infos.map((inf, j) => i === j ? {...inf, value} : inf)}))}
                            type={info.type}
                            fieldType={info.type === "image" ? InputFieldTypes.IMAGE : undefined}
                        />
                    </Box>
                    <ActionIcon onClick={() => {
                        setData(d => ({...d, infos: d.infos.filter((inf, j) => i !== j)}))
                    }}><FaTrash /></ActionIcon>
                </Group>
            ))
        }
        <Button size="xs" mt="md" leftIcon={<FaPlus />} onClick={() => {
            setData(d => ({...d, infos: [...(d?.infos ?? []), { type: "text" }]}))
        }} color="gray">Adicionar Info</Button>

        <Group position='right' mt="md">
            <Button size="sm" onClick={handleSave} loading={loadingSave} color="green">Salvar</Button>
        </Group>
    </>
}
